// extracted by mini-css-extract-plugin
var _1 = "ConfigurationField-moduleConfigurationField__OBOiU FormFieldContainer-moduleFormFieldContainer__OPJlF";
export { _1 as "ConfigurationField" }
